// extracted by mini-css-extract-plugin
export default {"boxSmall":"style_boxSmall__OhUkm","card":"style_card__heS2u"};